import type { RelationFieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import { defineAsyncComponent } from 'vue';
import { isRelationToMonospaceUsers } from '#layers/data-model/utils/relation';
import { FilterComponentNames } from '#layers/ui/public';

const UserSetupForm = defineAsyncComponent(() => import('#layers/data-model/components/User/SetupForm.vue'));

export const userFieldTypeTemplate: RelationFieldTypeTemplate = {
	type: 'relation',
	id: 'user',
	icon: 'lucide:circle-user',
	name: '$t:field_types.user.name',
	description: '$t:field_types.user.description',
	sort: 1150,
	keywords: ['person', 'member', 'account', 'owner', 'assignee'],
	supportedRelationTypes: ({ context }) => {
		const { existingField } = context;

		if (existingField && !isRelationToMonospaceUsers(existingField)) {
			return [];
		}

		// m2o leads so a new user field defaults to a non-exclusive single user; the exclusivity
		// toggle in the setup form flips it to o2o.
		return ['m2o', 'o2o', 'm2m'];
	},
	setupForm: UserSetupForm,
	setupDefaults: {
		target: {
			meta: {
				isHidden: true,
			},
		},
	},
	filter: {
		picker: FilterComponentNames.UserPicker,
		preview: FilterComponentNames.UserPreview,
		previewFields: ['id', 'fullName', 'email', 'avatarId'],
	},
};

export default userFieldTypeTemplate;
